export const translatedKeys = {
    MEDICAL_CERTIFICATE: "Atestado",
    VACATION: "Férias",
    DAY_OFF: "Folga",
    PAID_DAY_OFF: "Folga abonada",
    LICENSE: "Licença",
    SHIFT_CHANGE: "Troca de plantão",
    CAT: 'Atestado médico CAT',
    JUSTIFIED_ABSENCE: 'Falta justificada',
    UNJUSTIFIED_ABSENCE: 'Falta injustificada',
    PREMIUM_LICENSE: 'Licença prêmio',
    COMMERCIAL: "Comercial",
    COMMERCIAL6X1: "Comercial 6x1",
    "12X36": "12x36",
    "12X12X12X60": "12x12x12x60",
}